import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

//los logos van en blanco sobre el mismo vidrio que los botones de la vista 360
const logo = { size: 24, bgStyle: { fill: "transparent" }, iconFillColor: "#ffffff" };

const ShareComponent = ({ url, title }) => {
  const [copiado, setCopiado] = useState(false);

  const handleDownloadQR = async () => {
    try {
      // Generar QR específico para descarga con configuración optimizada
      const canvas = document.createElement('canvas');

      await QRCode.toCanvas(canvas, url, {
        width: 1000,           // Muy alta resolución
        margin: 4,             // Margen generoso
        color: {
          dark: '#000000',     // Negro puro
          light: '#FFFFFF'     // Blanco puro
        },
        errorCorrectionLevel: 'H',  // Máxima corrección de errores
        type: 'image/png',
        quality: 1.0,          // Máxima calidad
        rendererOpts: {
          quality: 1.0
        }
      });

      const imageUrl = canvas.toDataURL("image/png", 1.0);
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "qr-code-inmersial.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error al descargar QR:", error);
    }
  };

  const handleCopiar = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (error) {
      console.error("Error al copiar el enlace:", error);
    }
  };

  return (
    <div className="p360-share">
      <div className="p360-share-redes">
        <FacebookShareButton url={url} quote={title} className="p360-share-red" aria-label="Facebook">
          <FacebookIcon {...logo} />
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title} className="p360-share-red" aria-label="X">
          <TwitterIcon {...logo} />
        </TwitterShareButton>
        <WhatsappShareButton url={url} title={title} className="p360-share-red" aria-label="WhatsApp">
          <WhatsappIcon {...logo} />
        </WhatsappShareButton>
        <LinkedinShareButton url={url} title={title} className="p360-share-red" aria-label="LinkedIn">
          <LinkedinIcon {...logo} />
        </LinkedinShareButton>
      </div>

      <div className="p360-share-enlace">
        <input readOnly value={url} aria-label="Enlace de la experiencia" onFocus={(e) => e.target.select()} />
        <button type="button" className="p360-share-accion" onClick={handleCopiar}>
          {copiado ? "¡Copiado!" : "Copiar"}
        </button>
      </div>

      <div className="p360-share-qr">
        <p>O escaneá este código QR</p>
        <div className="p360-share-qr-marco">
          <QRCodeCanvas
            value={url}
            size={400}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={false}
            style={{ width: "128px", height: "128px" }}
          />
        </div>
        <button type="button" className="p360-share-secundario" onClick={handleDownloadQR}>
          Descargar QR
        </button>
      </div>
    </div>
  );
};

export default ShareComponent;
